import React, { ReactElement } from "react";
import { gql, useMutation } from "@apollo/client";
import { 
  DeactivateCustomerAdminMutation, 
  DeactivateCustomerAdminMutationVariables 
} from "../../../../../schemaTypes";
import { normalizeErrors } from "../../../../../utils/normalizeErrors";
import { NormalizedErrorMap } from "../../../../../types/NormalizedErrorMap";

const deactivateCustomerAdminMutation = gql`
  mutation DeactivateCustomerAdmin($input: DeactivateCustomerAdminInput!) {
    deactivateCustomerAdmin(input: $input) {
      errors {
        path
        message
      }
      message
    }
  }
`;

interface Props {
  children: (
    data: {
      submitDeactivateCustomerAdmin: (
        values: DeactivateCustomerAdminMutationVariables
      ) => Promise<NormalizedErrorMap | null>;
      loading: boolean;
      errors: NormalizedErrorMap | null;
      message: string | null;
    }
  ) => ReactElement | null;
}

export const DeactivateCustomerAdminController: React.FC<Props> = ({ children }) => {
  const [mutate, { loading, data }] = useMutation<
    DeactivateCustomerAdminMutation,
    DeactivateCustomerAdminMutationVariables
  >(deactivateCustomerAdminMutation);

  const errors = data?.deactivateCustomerAdmin?.errors
    ? normalizeErrors(data.deactivateCustomerAdmin.errors as any)
    : null;

  const submitDeactivateCustomerAdmin = async (values: DeactivateCustomerAdminMutationVariables) => {
    const response = await mutate({ variables: values });
    const deactivateCustomerAdmin = response?.data?.deactivateCustomerAdmin;
    if (deactivateCustomerAdmin?.errors) {
      return normalizeErrors(deactivateCustomerAdmin.errors as any);
    }
    
    return null;
  };

  const message = data?.deactivateCustomerAdmin?.message || null;

  return children({
    submitDeactivateCustomerAdmin,
    loading,
    errors,
    message
  });
};
